module.exports = __webpack_public_path__ + "img/welcome_bg_rg.755adb33.jpg";